import upload_area from "./upload_area.png";

export const image = { 
    upload_area
}